import { FiHome, FiPackage, FiShoppingBag, FiUsers, FiSettings, FiTrendingUp, FiStar, FiCreditCard, FiRotateCcw, FiHelpCircle, FiPercent } from "react-icons/fi";
import {
  MdOutlineStorefront,
  MdOutlineVerifiedUser,
  MdOutlineLocalOffer,
  MdOutlineCategory,
  MdOutlineImage,
  MdOutlineLocalShipping,
} from "react-icons/md";
import { BiChat } from "react-icons/bi";
import { MARKET } from "../../Routes/Marketplace/libs/marketplaceRoutes";

export const ADMIN_NAV = [
  { to: "/admin", label: "Overview", icon: FiHome, end: true },
  { to: "/admin/products", label: "Products", icon: FiPackage },
  { to: "/admin/deals", label: "Deals", icon: MdOutlineLocalOffer },
  { to: "/admin/merchants", label: "Merchants", icon: MdOutlineStorefront },
  { to: "/admin/verification", label: "Verification", icon: MdOutlineVerifiedUser },
  { to: "/admin/orders", label: "Orders", icon: FiShoppingBag },
  { to: "/admin/payouts", label: "Payouts", icon: FiCreditCard },
  { to: "/admin/returns", label: "Returns", icon: FiRotateCcw },
  { to: "/admin/commission", label: "Commission", icon: FiPercent },
  { to: "/admin/faq", label: "FAQ", icon: FiHelpCircle },
  { to: "/admin/customers", label: "Customers", icon: FiUsers },
  { to: "/admin/reviews", label: "Reviews", icon: FiStar },
  { to: "/admin/analytics", label: "Analytics", icon: FiTrendingUp },
  { to: "/admin/categories", label: "Categories", icon: MdOutlineCategory },
  { to: "/admin/banners", label: "Banners", icon: MdOutlineImage },
  { to: "/admin/shipping", label: "Shipping", icon: MdOutlineLocalShipping },
  { to: "/admin/messages", label: "Broadcast", icon: BiChat },
  { to: "/admin/settings", label: "Settings", icon: FiSettings },
];

export const ADMIN_FOOTER_LINKS = [
  { to: MARKET.HOME, label: "Go to marketplace" },
];
